import { useTranslation } from 'react-i18next';
import { LOGCLUSTER_URL, WFP_URL } from '@/shared/config';

export function Footer() {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const getWfpLogoUrl = (lang: string) => {
    const supportedLangs = ['en', 'es', 'fr', 'ar'];

    const langCode = supportedLangs.includes(lang) ? lang : 'en';
    return `/logos/black/wfp-logo-${langCode}.svg`;
  };

  return (
    <footer className="flex w-full justify-between items-center shrink-0 border-t border-border bg-background px-6 py-4">
      <div className="flex items-center">
        <a href={LOGCLUSTER_URL} target="_blank" rel="noopener noreferrer">
          <img src="/logos/black/logcluster-logo.svg" alt="LogCluster" className="h-10 w-auto" />
        </a>
      </div>

      <div className="flex items-center">
        <a href={WFP_URL} target="_blank" rel="noopener noreferrer">
          <img src={getWfpLogoUrl(currentLanguage)} alt="WFP" className="h-10 w-auto" />
        </a>
      </div>
    </footer>
  );
}
